import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { type SelectQuestionAnswerEditorViewModel } from '@/features/jobs/questions/select/SelectQuestionAnswerEditorViewModel'
import { AdvancedSelect } from '@/features/jobs/questions/select/components/AdvancedSelect'

export interface AdvancedSelectContainerProps {
  editorVm: SelectQuestionAnswerEditorViewModel
  questionId: string
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
}

export const AdvancedSelectContainer = observer(
  function AdvancedSelectContainer({
    editorVm,
    questionId,
    ...rest
  }: AdvancedSelectContainerProps) {
    return (
      <AdvancedSelect
        multi={editorVm.multi}
        options={editorVm.options}
        selected={editorVm.selected}
        onChange={editorVm.respond}
        testId={`select-advanced-${questionId}`}
        {...rest}
      />
    )
  },
)
